import { useState } from 'react';
import { Box } from '@mui/material';
import HierarchyValueList from './HierarchyValueList/HierarchyValueList';
import HierarchyRFMConfigHeader from './HierarchyRFMConfigHeader/HierarchyRFMConfigHeader';
import HierarchyConfigEdit from './HierarchyConfigEdit/HierarchyConfigEdit';
import useHierarchyRFMConfig from '../hooks/useHierarchyRFMConfig';

const HierarchyRFMConfigContainer = () => {
  const { hierarchyRFMConfig } = useHierarchyRFMConfig();
  const [hierarchyBeingEdited, setHierarchyBeingEdited] = useState<
    string | null
  >(null);

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={'1rem'}
    >
      {!hierarchyBeingEdited && <HierarchyRFMConfigHeader />}
      {hierarchyBeingEdited ? (
        <HierarchyConfigEdit
          segments={hierarchyRFMConfig?.value[hierarchyBeingEdited] ?? []}
          hierarchyValue={hierarchyBeingEdited}
          setEditing={setHierarchyBeingEdited}
        />
      ) : (
        <HierarchyValueList setEditing={setHierarchyBeingEdited} />
      )}
    </Box>
  );
};

export default HierarchyRFMConfigContainer;
